export default __webpack_public_path__ + "static/media/popover-position-top.d52a8e85.svg";